import { Timeline } from 'antd'
import React, { useEffect, useState } from 'react'
import { FootprintContent } from '../dashboard.styled'
import ChartHeader from './ChartHeader'

function Footprint (props) {
  const { data, settingMode } = props
  const { UISetting, content } = data || {}
  const { limit } = UISetting
  const [items, setItems] = useState([])

  useEffect(() => {
    const fakeData = Array.from({ length: Number(limit) || 5 }, (_, i) => ({ label: `Timeline ${i + 1}`, children: `Content ${i + 1}` }))
    const footprintData = settingMode
      ? fakeData
      : content?.data?.map(i => {
        let children = i.value
        if (typeof children === 'string' && /<\/?[a-z][\s\S]*>/i.test(children)) children = <div dangerouslySetInnerHTML={{ __html: children }} />
        return ({ label: i.label, children })
      }) || fakeData // changeLater
    setItems(footprintData)
  }, [])

  return (
    <>
      <ChartHeader {...props} />
      <FootprintContent><Timeline mode="left" items={items} /></FootprintContent>
    </>
  )
}

export default Footprint
